// storageUsage.js — plain-language help when the browser's localStorage is full.
//
// Why: every report editor keeps its data in localStorage, which holds only ~5 MB per website. All projects
// (and their replaced photos) share that one space, so after a while a save fails with
// "Setting the value of '...' exceeded the quota". This turns that error into a message that says what
// happened and which saved items take the most room, instead of the raw browser text.

export const isQuotaError = (err) =>
  !!err && (err.name === 'QuotaExceededError' || err.code === 22 || err.code === 1014 || /quota/i.test(String(err.message || '')));

// Biggest keys first: [{ key, kb }]
export const largestStorageKeys = (limit = 5) => {
  try {
    const rows = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      const value = localStorage.getItem(key) || '';
      rows.push({ key, kb: Math.round(((key.length + value.length) * 2) / 1024) });
    }
    return rows.sort((a, b) => b.kb - a.kb).slice(0, limit);
  } catch (e) {
    return [];
  }
};

export const describeSaveError = (err) => {
  if (!isQuotaError(err)) return err && err.message ? err.message : String(err);
  const top = largestStorageKeys(5);
  const list = top.length ? '\n\nBiggest saved items in this browser:\n' + top.map((r) => `• ${r.key}  (${r.kb >= 1024 ? (r.kb / 1024).toFixed(1) + ' MB' : r.kb + ' KB'})`).join('\n') : '';
  return 'Your browser storage is full, so this report could not be saved.\n\n'
    + 'To fix it: save your finished projects, delete old projects you no longer need, or remove large replaced photos from the reports (use "Reset" under the photo). '
    + 'Opening the project in a new Incognito window also works for now.'
    + list;
};
